export enum LEADS_MODULE_IDS {
  LEADS = "LEADS|LEADS|LATEST_LEADS_WITHOUT_OPPORTUNITY_STATUS",
  FOLLOW_UP = "LEADS|FOLLOWUP|LATEST_FOLLOWUP",
  OPPORTUNITY = "OPPORTUNITY|OPPORTUNITY|LATEST_LEAD_WITH_OPPORTUNITY",
}

export enum LEADS_MODULE_NAMES {
  LEADS = "Leads",
  FOLLOW_UP = "Follow Up",
  OPPORTUNITY = "Opportunity",
}

export enum LEADS_TEMPLATE_RELATED_MODULE_ID {
  LEAD = "LEAD",
  FOLLOW_UP = "FOLLOW_UP",
}

export enum LEADS_MASTER_DROP_DOWN_CODES {
  LEADS_FOLLOWUP_TYPE = "1022114605",
}
